module.exports = __webpack_public_path__ + "static/media/OPTOUT.d2109ddd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/OPTOUT.jpg
// module id = 1356
// module chunks = 0